

























































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

interface Banka {
  id: number;
  isim: string;
}

interface Hesap {
  id?: number;
  isim: string;
  banka_id: number | null;
  para_birimi_id: number | null;
  sube_adi: string;
  hesap_numarasi: string;
  iban: string;
  hesap_tipi: string;
  uyap_banka_hesabi_id: string;
}

@Component
export default class Bankalar extends Vue {
  searchBankalar: string = "";
  searchBankaHesaplari: string = "";
  loading: boolean = false;
  bankalar: Banka[] = [];
  bankaHeaders = [
    { text: "ID", value: "id" },
    { text: "İsim", value: "isim" },
    { text: "İşlemler", value: "actions", sortable: false, align: "right" }
  ];

  bankaHesaplari: Hesap[] = [];
  bankaHesaplariLoading: boolean = false;
  bankaHesaplariHeaders = [
    { text: "ID", value: "id" },
    { text: "İsim", value: "isim" },
    { text: "IBAN", value: "iban" },
    { text: "Hesap Tipi", value: "hesap_tipi" },
    { text: "İşlemler", value: "actions", sortable: false, align: "right" }
  ];

  editHesapDialog: boolean = false;
  formValid: boolean = false;
  isEditingHesap: boolean = false;
  hesap: Hesap = {
    isim: "",
    banka_id: null,
    para_birimi_id: null,
    sube_adi: "",
    hesap_numarasi: "",
    iban: "",
    hesap_tipi: "",
    uyap_banka_hesabi_id: ""
  };

  paraBirimleri = [
    { id: 1, isim: "TL" },
    { id: 2, isim: "USD" },
    { id: 3, isim: "EUR" }
  ];

  hesapTipleri = [
    { text: "IBAN", value: "iban" },
    { text: "Hesap Numarası", value: "hesap_numarasi" }
  ];

  rules = {
    banka_id: [(v: any) => !!v || "Banka seçimi zorunludur."],
    para_birimi_id: [(v: any) => !!v || "Para birimi seçimi zorunludur."],
    hesap_tipi: [(v: any) => !!v || "Hesap tipi zorunludur."],
    iban: [
      (v: any) =>
          this.hesap.hesap_tipi === "iban"
              ? !!v || "IBAN alanı zorunludur."
              : true
    ],
    hesap_numarasi: [
      (v: any) =>
          this.hesap.hesap_tipi === "hesap_numarasi"
              ? !!v || "Hesap numarası alanı zorunludur."
              : true
    ]
  };

  banka: Banka = { id: 0, isim: "" };
  editBankaDialog: boolean = false;
  bankaFormValid: boolean = false;
  isEditingBanka: boolean = false;

  mounted() {
    this.loadBankalar();
    this.loadBankaHesaplari();
  }

  loadBankalar() {
    this.loading = true;
    axios
        .get(this.$store.state.icwApiUrl + "admin/bankalar")
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            this.bankalar = response.data;
          } else if (response.data && Array.isArray(response.data.data)) {
            this.bankalar = response.data.data;
          } else {
            console.error("Beklenmeyen API yanıt formatı:", response.data);
            this.bankalar = [];
          }
        })
        .catch((error) => {
          console.error("Bankalar yüklenirken hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false;
        });
  }

  loadBankaHesaplari() {
    this.bankaHesaplariLoading = true;
    axios
        .get(this.$store.state.icwApiUrl + "admin/banka-hesaplari")
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            this.bankaHesaplari = response.data;
          } else if (response.data && Array.isArray(response.data.data)) {
            this.bankaHesaplari = response.data.data;
          } else {
            console.error("Beklenmeyen API yanıt formatı:", response.data);
            this.bankaHesaplari = [];
          }
        })
        .catch((error) => {
          console.error("Banka hesapları yüklenirken hata oluştu:", error);
        })
        .finally(() => {
          this.bankaHesaplariLoading = false;
        });
  }

  addBanka() {
    this.isEditingBanka = false;
    this.banka = { id: 0, isim: "" };
    this.editBankaDialog = true;
  }

  editBanka(item: Banka) {
    this.isEditingBanka = true;
    this.banka = { ...item };
    this.editBankaDialog = true;
  }

  closeBankaDialog() {
    this.editBankaDialog = false;
  }

  saveBanka() {
    const url = (this.$store.state.icwApiUrl || "") + "admin/banka";
    const payload: any = { isim: this.banka.isim };
    if (this.isEditingBanka && this.banka.id) {
      payload.id = this.banka.id;
    }

    axios
      .post(url, payload)
      .then((response) => {
        // Başarılı ise listeyi tazele ve diyalogu kapat
        this.loadBankalar();
        this.closeBankaDialog();
      })
      .catch((error) => {
        console.error("Banka kaydedilirken hata oluştu:", error);
      });
  }

  addBankaHesap() {
    this.isEditingHesap = false;
    this.resetHesapForm();
    this.editHesapDialog = true;
  }

  editBankaHesap(item: Hesap) {
    this.isEditingHesap = true;
    this.hesap = { ...item };
    this.editHesapDialog = true;
  }

  closeHesapDialog() {
    this.editHesapDialog = false;
  }

  resetHesapForm() {
    this.hesap = {
      isim: "",
      banka_id: null,
      para_birimi_id: null,
      sube_adi: "",
      hesap_numarasi: "",
      iban: "",
      hesap_tipi: "",
      uyap_banka_hesabi_id: ""
    };
  }

  submitHesap() {
    const form = this.$refs.hesapForm as any;
    if (form.validate()) {
      if (this.isEditingHesap) {
        const index = this.bankaHesaplari.findIndex(
            (h) => h.id === this.hesap.id
        );
        if (index !== -1) {
          this.bankaHesaplari.splice(index, 1, { ...this.hesap });
        } else {
          this.bankaHesaplari.push({ ...this.hesap, id: Date.now() });
        }
      } else {
        const newHesap = { ...this.hesap, id: Date.now() };
        this.bankaHesaplari.push(newHesap);
      }
      this.resetHesapForm();
      this.editHesapDialog = false;
    } else {
      console.log("Form geçerli değil.");
    }
  }
}
